import { render, staticRenderFns } from "./ReportsListItem.vue?vue&type=template&id=4d07c0d0&"
import script from "./ReportsListItem.vue?vue&type=script&lang=js&"
export * from "./ReportsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports